<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Digitally Renewed Cases ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showCbsDataTable">

  <!-- <input type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date1 style="
  height: 35px;
    border-color: rgb(223, 223, 223);
    box-shadow: 0 2px 3px 0 rgba(179, 179, 179, 0.2), 0 3px rgba(177, 177, 177, 0.19);
    border-radius: 4px;
    border-left: 0px solid rgb(223, 223, 223);
    border-right: 0px solid rgb(223, 223, 223); 
    border-top: 1px solid rgb(236, 236, 236); 
    border-bottom: 0px solid rgb(223, 223, 223);
  ">

  <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;      <img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
</span>


<!-- <button (click)="test()" >Test</button> -->

  <ng-template #elseBlock>
    <div class="float-left">
      <button class="mybutton" *ngIf="!reportLink" (click)="getLogReport()">View Log Report</button>
    </div>
  </ng-template>


  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>
  

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Account No.</th>
          <!-- <th>Status</th> -->
          <th>Name</th>
          <th >Mobile No.</th>
          <th class="text-left">Proposed <br>DP</th>
          <th>CBS Approval <br>Date</th>
          <th>Next Renewal<br>Date</th>
          <th>Actions </th>


          
          <!-- <th class="text-center">Actions</th> -->
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">


          <!-- <div  > -->

          <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>
          <td class="vertical-align-middle">{{user?.user_docs?.kcc_acc_no_unMasked}}</td>
          <td class="vertical-align-middle w-16pct">{{user.profile.name}}</td>
          <td  class="vertical-align-middle">{{user.profile.mobileNo}}</td>
          <td class="vertical-align-middle">{{user?.final_form_submitted_data?.proposed_dp_k?user?.final_form_submitted_data?.proposed_dp_k:"Not available"}}</td>

          <td class="vertical-align-middle">{{get_cbs_approved_date(i)}}</td>
          <td class="vertical-align-middle">{{get_next_renewal_date(i)}}</td>

          <td class="vertical-align-middle">            <a class="text-no-decoration cursor-pointer text-blue" color="primary" target="_blank"
            (click)="printDes(user.id)">Print DES</a> | <a class="text-no-decoration cursor-pointer text-blue" color="primary" target="_blank"
            (click)="printConsent(user.id)">Print Consent form</a></td>
          


        </tr>
      </tbody>
    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>


</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->